module.exports = __webpack_public_path__ + "static/0-2dd194e4ee9712b7808cfe22e033eba6.jpg";